module.exports = __webpack_public_path__ + "img/avatar-male.fdf0b88f.svg";